export const ROOM_COLLECTION_NAME = "talkrooms" as const;
export const ROOMS_STORE_KEY = "rooms" as const;
export const MESSAGE_SUB_COLLECTION_NAME = "messages" as const;
export const TALK_ROOM_LIST_TITLE = "トークリスト" as const;
